import React from 'react';
import { Flex, Box, Input, Select, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { STATUS_FILTER_OPTIONS } from 'api/administrador/monitoring/zoomRecordings';

/**
 * Filtros de la TABLA: status + búsqueda. El periodo vive arriba de los KPIs
 * (en la página) porque gobierna contadores y tabla a la vez.
 */
export default function ZoomLogFilters({ filters, onChange }) {
  const updateFilter = (key, value) => onChange({ ...filters, [key]: value, page: 1 });

  return (
    <Flex gap={3} align="center" wrap="wrap" mb={4}>
      <Select
        value={filters.status}
        onChange={(e) => updateFilter('status', e.target.value)}
        maxW="200px"
        size="md"
        bg="white"
      >
        {STATUS_FILTER_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </Select>

      <InputGroup maxW="360px" ml="auto">
        <InputLeftElement pointerEvents="none">
          <Box color="gray.400"><FiSearch /></Box>
        </InputLeftElement>
        <Input
          placeholder="Buscar por meeting ID, correo o tema…"
          value={filters.search}
          onChange={(e) => updateFilter('search', e.target.value)}
          bg="white"
        />
      </InputGroup>
    </Flex>
  );
}
